/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
console.log("custom.js loaded");
 
console.log("🔧 Add to Cart tracker (form-submit version) loaded");

const TRACKED_PRODUCTS = [
  "event-stationery-consultations",
  "virtual-event-stationery-consultations",
  "wax-sealing-workshops",
  "invitation-sample-packs",
];

const STORAGE_KEY = "pending_tracked_add_to_cart";

// --- STEP 1: capture the Add to Cart click on the product page, before navigation ---
// NOTE: we listen for "click" rather than "submit" because if the product
// options app calls form.submit() programmatically (rather than
// form.requestSubmit()), the browser's native form.submit() method does
// NOT fire a "submit" event at all — it's a long-standing browser quirk.
// A real user click always fires, though, so we catch it there instead,
// using the capture phase so we see it before the app's own click handler
// can stop propagation or prevent default.
document.addEventListener(
  "click",
  function (event) {
    const button = event.target.closest('button[type="submit"]');
    if (!button) return;

    const form = button.closest("form");
    const isAddToCartForm =
      form && (form.action.indexOf("/cart/add") !== -1 || form.querySelector('input[name="id"]'));

    if (!isAddToCartForm) return;

    // We're still on the product page at this point, so the URL is reliable.
    const handle = window.location.pathname.replace(/^\/products\//, "").split("?")[0];

    console.log("📝 Add to cart button clicked, handle:", handle);

    if (!TRACKED_PRODUCTS.includes(handle)) return;

    const variantInput = form.querySelector('input[name="id"]');
    const variantId = variantInput ? variantInput.value : null;

    try {
      sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          product_handle: handle,
          variant_id: variantId,
          ts: Date.now(),
        })
      );
      console.log("💾 Stashed pending add-to-cart for", handle);
    } catch (err) {
      console.error("Could not write to sessionStorage:", err);
    }
    // Do NOT call preventDefault() — let the app's own logic and the
    // native navigation continue exactly as before.
  },
  true // capture phase — fires before the app's own click handler on the button
);

// --- STEP 2: on every page load, check if there's a pending event to fire ---
(function flushPendingAddToCart() {
  let pending;
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return;
    pending = JSON.parse(raw);
  } catch (err) {
    return;
  }

  // Only fire it once, and only if it's recent (avoid stale data from an
  // abandoned/failed submission firing on some unrelated later page view).
  const isRecent = pending.ts && Date.now() - pending.ts < 60000; // 60s window
  if (!isRecent) {
    sessionStorage.removeItem(STORAGE_KEY);
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "tracked_product_add_to_cart",
    product_handle: pending.product_handle,
    variant_id: pending.variant_id,
  });

  console.log("✅ DataLayer event pushed (from stashed submit):", pending);

  sessionStorage.removeItem(STORAGE_KEY);
})();